<account-back [link]="'/account/edit'"
              class="m-b-9 m-b-7-s m-b-7-m m-t--1 block p-l-2"
              [title]="sectionTitle"></account-back>

<account-form>
    <p class="p1">{{ inFormTitle }}</p>

    <!-- prefix -->
    <div class="m-t-9">
        <ng-content></ng-content>
    </div>

    <!-- submission -->
    <div class="m-t-9">

        <div [grid]="2"
             *ifSize="'XL'"
             [gridColumnGap]="'20px'">
            <action class="button-1 w-12"
                    [gridColumn]="1"
                    (click)="source.close()">{{'Cancel' |translate}}
            </action>

            <action class="button w-12"
                    [gridColumn]="1"
                    (click)="source.submit()"
                    [status]="source.status">
                {{ 'Save changes' | translate }}
            </action>
        </div>

        <ng-container *ifSize="'SM'">
            <action class="button w-12 m-b-5"
                    [gridColumn]="1"
                    (click)="source.submit()"
                    [status]="source.status">
                {{ 'Save' | translate }}
            </action>

            <action class="button-1 w-12"
                    [gridColumn]="1"
                    (click)="source.close()">{{'Cancel' |translate}}
            </action>
        </ng-container>

    </div>

    <result [status]="source.status"></result>

</account-form>